import axios from 'axios';

const addNewShop = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/dealer`, data)
    .then(res => res)
    .catch(err => err);
};

export default addNewShop;
